"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParseError_1 = require("../errors/ParseError");

var ParamsParser_1 = require("../ParamsParser");

function paramParser(start, end, params) {
  if (params) {
    var parser = new ParamsParser_1.ParamsParser();

    try {
      return parser.parse(params);
    } catch (e) {
      throw new ParseError_1.default(e.message, {
        start: start + e.start,
        end: end
      });
    }
  } else {
    return undefined;
  }
}

exports.paramParser = paramParser;